import React from 'react';
import styles from './../FoodPage.module.css';
import { BaseNutritionItem } from './types';
import { useTranslation } from '../../../i18n/provider';

interface ExpandableItemProps {
  item: BaseNutritionItem;
  isExpanded: boolean;
  onToggle: () => void;
}

const ExpandableItem: React.FC<ExpandableItemProps> = ({ item, isExpanded, onToggle }) => {
  const { t } = useTranslation();
  return (
    <div 
      className={`${styles.item} ${isExpanded ? styles.expanded : ''}`}
      onClick={onToggle}
    >
      <div className={styles.header}>
        <span className={styles.component}>{item.component}</span>
        <span className={styles.summary}> - <i>{item.summary}</i></span>
      </div>
      <p className={styles.role}>{item.role}</p>
      {item.sources && (
        <p className={styles.sources}>
          <strong>{t('shared.expandable.sources')}:</strong> {item.sources}
        </p>
      )}
      <div className={styles.expandIndicator}>
        {isExpanded ? t('shared.expandable.collapse') : t('shared.expandable.expand')}
      </div>
    </div>
  );
};

export default ExpandableItem;
